import { Link, useLocation } from "react-router-dom";

export const PhotoWidget = () => {
  const { pathname } = useLocation();
  if (pathname === "/foto" || pathname === "/admin") return null;
  return (
    <Link
      to="/foto"
      aria-label="Foto degli ospiti"
      title="Foto degli ospiti"
      data-testid="photo-widget-link"
      className="fixed bottom-5 right-5 md:bottom-6 md:right-6 z-50 w-14 h-14 rounded-full bg-w-sage text-white flex items-center justify-center shadow-lg hover:bg-w-sage/90 hover:-rotate-6 hover:scale-105 transition-transform duration-300"
    >
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="4" y="2.5" width="16" height="19" rx="1.5" />
        <rect x="6.5" y="5" width="11" height="10" rx="0.5" />
        <circle cx="12" cy="10" r="2.2" />
        <line x1="9" y1="18.3" x2="15" y2="18.3" />
      </svg>
    </Link>
  );
};
